import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Container, ListGroupItem } from 'reactstrap'

class LandingPage extends Component {

  render() {
    return <Container fluid>
      <div className="content-frame" style={{ paddingBottom: 40 }}>

        <div style={{ paddingTop: 56 + 16}}>
          <h1 style={{ fontWeight: "heavy", marginBottom: 20, color: "#432342" }}>About Me</h1>
          <div style={{ fontSize: 20 }}>
            <p style={{ marginBottom: 20 }}>I'm a Postdoctoral Researcher at the <a href="http://clp.ling.uni-potsdam.de/" style={{ color: "#5C475A", whiteSpace: "nowrap" }}>colab Potsdam</a> (University of Potsdam, Germany)
              looking into how people converse with robots. I've received my PhD from Uppsala University, Sweden, in
              Computer Science with a Specialization in Human-Computer Interaction in October 2020. In my <a href="https://www.diva-portal.org/smash/record.jsf?pid=diva2:1464377" style={{ color: "#5C475A", whiteSpace: "nowrap" }}>thesis</a>, I discuss
              the effect that novelty plays in people's uncanny feeling towards robots.
            </p>
            <p>Originally I studied Computer Science at the University of Hamburg, Germany, and focused on both
              humanoid robotics and conversational interaction. I wrote my Master thesis in cooperation with the University of Southern California on
              building the incremental dialogue system Eve that can engage in a rapid image matching game. During my PhD, I have
              expanded the game agent to engage in the geography-themed cooperative game RDG-Map.
              Apart from Human-Robot Interaction, my heart belongs to the RoboCup community.
              Since 2011 I'm involved in the RoboCup Humanoid League, first as one of the founders of the
              team <a href="https://bit-bots.de/" style={{ color: "#5C475A", whiteSpace: "nowrap" }}>Hamburg Bit-Bots</a> and since 2015, I'm actively engaged in the Technical Committee of the league. In 2021, I joined the Berlin-based RoboCup team <a href="https://01.rfc-berlin.de/" style={{ color: "#5C475A", whiteSpace: "nowrap" }}>01. RFC Berlin</a>.
            </p>
            <p>
              When I'm not researching or tinkering with robots, you will most likely find me on the dance floor dancing
              Kizomba, Urban Kiz, Bachata or ballroom dances, bouldering, playing cooperative boardgames with friends,
              or reading a book.
            </p>
          </div>
        </div>
        <div style={{ marginTop: 40 }}>
          <h1 style={{ fontWeight: "heavy", marginBottom: 20, color: "#432342" }}>News</h1>
          <ListGroupItem className="justify-content-between" style={{ marginTop: 10 }}>
            <h4 style={{ fontWeight: "heavy", color: "#5C475A" }}>Appointed RA-L Associate Editor</h4>
            <div>
              I was appointed by the IEEE Robotics & Automation Society to serve as an Associate Editor for the RA Letters, working with
              Senior Editor Angelika Peer on the area of Human-Robot Interaction. Looking very much forward to this new responsibility of
              overseeing the reviewing process for RA-L!
            </div>
            <div style={{ fontSize: 14, textAlign: "right", marginTop: 10 }}>
              Published: 08/02/2022
            </div>
          </ListGroupItem>
          <ListGroupItem className="justify-content-between" style={{ marginTop: 10 }}>
            <h4 style={{ fontWeight: "heavy", color: "#5C475A" }}>Project on video-based documentation</h4>
            <div>
              I have been working together with "Software für Engagierte" and created (German) tutorials about using OBS and Shotcut for
              video-based documentation. The result is available open-source on <a
                href={"https://community.software-fuer-engagierte.de/t/video-orientiertes-dokumentieren/132"}
                target={"_blank"} style={{ color: "#5C475A", whiteSpace: "nowrap" }}>this website</a>.
            </div>
            <div style={{ fontSize: 14, textAlign: "right", marginTop: 10 }}>
              Published: 28/01/2022
            </div>
          </ListGroupItem>
          <ListGroupItem className="justify-content-between" style={{ marginTop: 10 }}>
            <h4 style={{ fontWeight: "heavy", color: "#5C475A" }}>Our robots featured on ARTE!</h4>
            <div>
              Arte made a <a
                href={"https://www.arte.tv/de/videos/101938-004-A/42-die-antwort-auf-fast-alles/"}
                target={"_blank"} style={{ color: "#5C475A", whiteSpace: "nowrap" }}>documentary</a> titled:
              "Werden wir Roboter lieben?" (will we love robots?) featuring our NAO and Furhat robot!
              Filming this was a lot of fun - especially Furhat really loved the camera and gave some pretty good interview responses.
            </div>
            <div style={{ fontSize: 14, textAlign: "right", marginTop: 10 }}>
              Published: 21/01/2022
            </div>
          </ListGroupItem>
          <ListGroupItem className="justify-content-between" style={{ marginTop: 10 }}>
            <h4 style={{ fontWeight: "heavy", color: "#5C475A" }}>RoboCup Humanoid League - Virtual Season</h4>
            <div>
              We have started a new initiative within the RoboCup Humanoid League to keep the simulated environment and
              games we developed for the world championship 2021 alive: From December onward, we will be playing a
              <a
                  href={"https://humanoid.robocup.org/hl-vs2022/humanoid-league-virtual-season-2021-22/"}
                  target={"_blank"} style={{ color: "#5C475A", whiteSpace: "nowrap" }}>virtual season</a> with
              games being played every other weeks and streamed on our
              <a
                  href={"https://www.twitch.tv/robocuphumanoidfielda"}
                  target={"_blank"} style={{ color: "#5C475A", whiteSpace: "nowrap" }}>Twitch Channel</a>.
              Come and join our streams and engage with our
              amazing commentators we have every week!
            </div>
            <div style={{ fontSize: 14, textAlign: "right", marginTop: 10 }}>
              Published: 17/12/2021
            </div>
          </ListGroupItem>
          <ListGroupItem className="justify-content-between" style={{ marginTop: 10 }}>
            <h4 style={{ fontWeight: "heavy", color: "#5C475A" }}>IVA 2022 Doctoral Consortium Co-Chair</h4>
            <div>
              I will be joining the organizers of the  <a
                href={"https://ivaconference2022.ualg.pt/"}
                target={"_blank"} style={{ color: "#5C475A", whiteSpace: "nowrap" }}>IVA 2022</a>
              conference in Algarve, Portugal, together with Filipa Correia as Co-Chair for the Doctoral Consortium.
            </div>
            <div style={{ fontSize: 14, textAlign: "right", marginTop: 10 }}>
              Published: 01/12/2021
            </div>
          </ListGroupItem>
          <ListGroupItem className="justify-content-between" style={{ marginTop: 10 }}>
            <h4 style={{ fontWeight: "heavy", color: "#5C475A" }}>Frontiers Paper accepted!</h4>
            <div>
              I am thrilled that our paper "Does the Goal Matter? Emotion Recognition Tasks Can Change
              the Social Value of Facial Mimicry towards Artificial Agents" was accepted to be published in
              Frontiers Robotics & AI. This was a huge collaborative project and the analyses of the data we collected
              more than five years ago took us a really long time. It makes me even more proud that we finally managed
              to publish this work!
            </div>
            <div style={{ fontSize: 14, textAlign: "right", marginTop: 10 }}>
              Published: 03/11/2021
            </div>
          </ListGroupItem>
          <ListGroupItem className="justify-content-between" style={{ marginTop: 10 }}>
            <h4 style={{ fontWeight: "heavy", color: "#5C475A" }}>Tabula Rasa - Wissenschaft zum Anfassen</h4>
            <div>
              With the RoboCup-Team 01. RFC Berlin I am attending the event <a
                href={"https://www.urania.de/tabula-rasa-wissenschaft-zum-anfassen"}
                target={"_blank"} style={{ color: "#5C475A", whiteSpace: "nowrap" }}>"Tabula Rasa - Wissenschaft zum Anfassen"</a>
              which is part of the Berlin Science Week. If you are in Berlin on Saturday, October 30th, then stop by and
              say hello to Mickey, the first prototype of our robot platform.
            </div>
            <div style={{ fontSize: 14, textAlign: "right", marginTop: 10 }}>
              Published: 21/10/2021
            </div>
          </ListGroupItem>
          <ListGroupItem className="justify-content-between" style={{ marginTop: 10 }}>
            <h4 style={{ fontWeight: "heavy", color: "#5C475A" }}>Teaching in WiSe 2021/22</h4>
            <div>
              In the winter term (Wintersemester 2021/22) I will teach two courses: The first one is a
              Bachelor level course on object oriented programming ("Programmierung 1"),
              the second one is a Bachelor level seminar / project course in which we will look into dialogue
              systems for smart speakers, both from a theoretical and a practical perspective.
            </div>
            <div style={{ fontSize: 14, textAlign: "right", marginTop: 10 }}>
              Published: 01/10/2021
            </div>
          </ListGroupItem>
        </div>
      </div>
    </Container>

  }
}

export default withRouter(LandingPage)
